import { HL7_TERMINOLOGY_CODES_LICENSES, LICENSE_OPTION_CODES } from "fhir/constants";

export enum CareTeamMemberRole {
  Caregiver = 'Caregiver',
  RegisteredNurse = 'Registered Nurse',
  OrderingPhysician = 'Ordering Physician',
  EmergencyContact = 'Emergency Contact',
  AlternateCaregiver = 'Alternative Caregiver',
  CaseManager = 'Case Manager',
  // These roles are not currently in use and synomymous with OrderingPhysician
  Physician = 'Physician',
  PrimaryCarePhysician = 'Primary Care Physician'
}

export const CASE_MANAGER_CODES = [
  { code: LICENSE_OPTION_CODES.RegisteredNurse, system: HL7_TERMINOLOGY_CODES_LICENSES }
]
